
import React, {Component} from 'react'

class SummaryOverview extends Component 
{

    render()
    {
        return <div>
                    Summary Window
        </div>
    }
}

export default SummaryOverview;